import { Icon } from "@iconify/react";
import useStyles from "../../styles";

// --| Shared drag-and-drop-styled file picker. The "drag and drop" look is a
// --| native <input type="file"> stretched over a dashed box (browsers give
// --| real drag & drop on file inputs for free), matching the pattern already
// --| used in src/pages/resources/Resources.js.
const FileDropZone = ({ files = [], onFilesSelected, onRemoveFile, multiple = true, accept, subtitle }) => {
  const classes = useStyles();

  const handleChange = (e) => {
    if (e.target.files?.length > 0) {
      onFilesSelected(Array.from(e.target.files));
      e.target.value = "";
    }
  };

  return (
    <div>
      <div className={classes.pickercontainer}>
        <input
          type="file"
          className={classes.picker}
          onChange={handleChange}
          multiple={multiple}
          accept={accept}
        />
        <div className={classes.uploadflex}>
          <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div>
          <div>
            <h2 className={classes.uploadtitle}>Drag & drop your file</h2>
            <h6 className={classes.uploadsubtitle}>
              {subtitle || "Or click to browse . PDF, DOCX, PNG, WEBM . up to 20 MB"}
            </h6>
          </div>
        </div>
      </div>
      {files?.length > 0 && (
        <div className={classes.fileChipList}>
          {files.map((file, index) => (
            <div key={`${file?.name}-${index}`} className={classes.fileChip}>
              <span>{file?.name}</span>
              <Icon
                icon="mdi:close"
                className={classes.fileChipRemove}
                onClick={() => onRemoveFile(index)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FileDropZone;
